import {
  StyleSheet,
} from 'react-native';

import {
  primaryFont500,
} from '../Common';

export default StyleSheet.create({
  panel_hover: {
    backgroundColor: '#e0e0e0',
  },
  panel: {
    flex: 0,
    flexDirection: 'row',
    minHeight: 64,
    height: 64,
    margin: 0,
    padding: 0,
    marginHorizontal: 10,
    borderRadius: 10,
    marginVertical: 10,
    paddingLeft: 10,
  },
  blockPoint: {
    width: 40,
    minHeight: 64,
    height: 64,
    margin: 0,
    padding: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  panelInner: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 64,
    height: 64,
    margin: 0,
    padding: 0,
  },
  panelInnerWithImages: {
    flex: 1,
    justifyContent: 'center',
    minHeight: 64,
    height: 64,
    margin: 0,
    padding: 0,
  },
  namePanel: {
    flexDirection: 'row',
    margin: 0,
    padding: 5,
    width: '100%',
  },
  name: {
    margin: 0,
    padding: 0,
    paddingHorizontal: 5,
    fontSize: 14,
    fontFamily: primaryFont500,
    fontWeight: '500',
    lineHeight: 17,
    textWrap: 'wrap', // ? no-wrap?
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  desc: {
    margin: 0,
    padding: 0,
    paddingHorizontal: 5,
    fontSize: 14,
    fontFamily: primaryFont500,
    fontWeight: 'normal',
    lineHeight: 17,
    textWrap: 'wrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  panelImages: {
    flexDirection: 'row',
    minHeight: 32,
    height: 32,
    margin: 0,
    padding: 0,
    paddingHorizontal: 10,
    overflow: 'hidden',
  },
  image: {
    width: 32,
    minHeight: 32,
    height: 32,
    margin: 0,
    marginRight: 4,
    padding: 0,
    // resizeMode: 'cover',
  },
  blockPlay: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 54,
    minHeight: 38,
    height: 38,
    margin: 0,
    padding: 0,
    marginTop: 13,
    borderRadius: 3,
  },
  play: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    minHeight: 24,
    height: 24,
    margin: 0,
    padding: 0,
    // resizeMode: 'cover',
    // TODO(clairbee): transform to primaryColor by filters
    //                 https://github.com/iyegoroff/react-native-color-matrix-image-filters#supported-filters
    // filter: 'invert(100%)',
    // filter: 'hue-rotate(90deg)',
  },
});
